import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogout } from "../coreFIles/auth";
import config from "../coreFIles/config";

export default function Header({ title }) {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const logout = () => {
    adminLogout();
    const base = (config.baseUrl || "/").replace(/\/+$/, "") || "/";
    navigate(`${base}/login`.replace("//", "/"), { replace: true });
  };

  useEffect(() => {
    const onMouseDown = (e) => {
      if (!menuRef.current) return;
      if (!menuRef.current.contains(e.target)) setMenuOpen(false);
    };
    const onKeyDown = (e) => {
      if (e.key === "Escape") setMenuOpen(false);
    };
    document.addEventListener("mousedown", onMouseDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onMouseDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, []);

  return (
    <header className="topbar">
      <div className="topbar-left">
        <h1>{title}</h1>
      </div>
      <div className="topbar-right">
        <div className="notification-bell" title="Notifications">
          🔔<div className="notification-dot" />
        </div>
        <div className="user-menu" ref={menuRef}>
          <button
            className="avatar"
            type="button"
            title="Admin menu"
            aria-haspopup="menu"
            aria-expanded={menuOpen ? "true" : "false"}
            onClick={() => setMenuOpen((v) => !v)}
          >
            AD
          </button>

          {menuOpen ? (
            <div className="user-dropdown" role="menu">
              <button className="user-dropdown-item" type="button" role="menuitem" onClick={logout}>
                Logout
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </header>
  );
}

